module.exports = __webpack_public_path__ + "assets/img/sample.2ed092e5.gif";